import { Component, Input } from '@angular/core';
import { Block } from '../../models/report.model';

@Component({
    selector: 'app-summary-table',
    templateUrl: './summary-table.component.html',
    styleUrl: './summary-table.component.scss',
})
export class SummaryTableComponent {
    // more blocks...
    @Input() tableData: Block[];
    totalData: any;
    eisData: any;
    neisData: any;

    grandTotal: any = {};
    ngOnInit(): void {
        if (this.tableData) {
            this.totalData = this.tableData.map((b) => ({
                block: b.block,
                // unit: b.unit,
                equipment: b.total.equipments,
                recEquip: b.total.receivedEquipments,
                recJoint: b.total.receivedJoints,
                uploaded: b.total.idmsUploaded,
                printed: b.total.tagsPrinted,
                tagged: b.total.jointsTagged,
            }));
            this.eisData = this.tableData.map((b) => ({
                equipment: b.eis.equipments,
                recEquip: b.eis.receivedEquipments,
                recJoint: b.eis.receivedJoints,
                uploaded: b.eis.idmsUploaded,
                printed: b.eis.tagsPrinted,
                tagged: b.eis.jointsTagged,
            }));
            this.neisData = this.tableData.map((b) => ({
                equipment: b.neis.equipments,
                recEquip: b.neis.receivedEquipments,
                recJoint: b.neis.receivedJoints,
                uploaded: b.neis.idmsUploaded,
                printed: b.neis.tagsPrinted,
                tagged: b.neis.jointsTagged,
            }));
        }
    }

    percentText(_: any) {
        return '100%';
    }
}
